import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=0e454c52&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=0e454c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e454c52",
  null
  
)

export default component.exports